// membershipAPI.js
import { firestore } from '../firebase.config'; // Adjust the path if necessary
import { collection, query, where, onSnapshot, orderBy, limit, startAfter, getDocs } from 'firebase/firestore';


export const fetchPendingRequests = (setRequests) => {
  const requestsRef = collection(firestore, "MembershipRequests");
  const q = query(requestsRef, where("status", "==", "pending"));

  // Listen to real-time updates
  const unsubscribe = onSnapshot(q, (snapshot) => {
    setRequests(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
  });

  // Return the unsubscribe function for cleanup
  return unsubscribe;
};

export const fetchInitialItems = (setData, setFilteredData, setLoadingMore, setLastVisible) => {
    setLoadingMore(true);
  
    const membershipCollectionRef = collection(firestore, "MembershipMaster");
    const q = query(
      membershipCollectionRef,
      orderBy('membershipEndDate'),
      limit(5) // Fetch the first 5 items
    );
  
    // Real-time listener to fetch initial data
    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const newData = [];
      querySnapshot.forEach((doc) => {
        newData.push({ id: doc.id, ...doc.data() });
      });
  
      setData(newData);
      console.log("Fetched data:", newData); 
      setFilteredData(newData);
      setLastVisible(querySnapshot.docs[querySnapshot.docs.length - 1]); // Save last visible for pagination
      setLoadingMore(false);
    });
  
    // Return the unsubscribe function for cleanup
    return unsubscribe;
  };
  

  export const fetchMoreItems = async (setData, setLastVisible, setLoadingMore, loadingMore, lastVisible, setFilteredData) => {
    if (loadingMore || !lastVisible) return;
  
    setLoadingMore(true);
  
    try {
      const membershipCollectionRef = collection(firestore, "MembershipMaster");
      const q = query(
        membershipCollectionRef,
        orderBy('membershipEndDate'),
        startAfter(lastVisible), // Start after the last fetched item
        limit(5) // Fetch the next 5 items
      );
  
      const querySnapshot = await getDocs(q);
  
      if (!querySnapshot.empty) {
        const moreItems = [];
        querySnapshot.forEach((doc) => {
          moreItems.push({ id: doc.id, ...doc.data() });
        });
  
        setData((prevData) => [...prevData, ...moreItems]); // Append new data to existing data
        setFilteredData((prevData) => [...prevData, ...moreItems]);
        console.log("Fetched data:", moreItems);
        setLastVisible(querySnapshot.docs[querySnapshot.docs.length - 1]); // Update the last visible document
      } else {
        setLastVisible(null); // No more items to fetch
      }
    } catch (error) {
      console.error('Error fetching more items:', error);
    }
  
    setLoadingMore(false);
  };
